import styles from '@/data/styles'
import TelegramIcon from "@/components/Icons/messengerComponent/TelegramIcon.vue";
import ViberIcon from "@/components/Icons/messengerComponent/ViberIcon.vue";
import WhatsAppIcon from "@/components/Icons/messengerComponent/WhatsAppIcon.vue";
import tariffPackages from "@/data/tariffPackages";
import replaceDotToComma from "@/helpers/replaceDotToComma.js";

const { viber, telegram, whatsapp } = tariffPackages.tariffs

export default function () {
    const description = 'components.tariffs.base.description2'
    const tariffsBlock = [
        {
            title: 'Viber',
            price: replaceDotToComma(viber.number1.month1),
            description,
            list: 'components.tariffs.base.info',
            color: styles.colors.viber,
            secondColor: styles.opacityColors.viber,
            iconComponent: ViberIcon,
            iconHeight: 19,
            type: 'viber',
        },
        {
            title: 'Telegram',
            price: replaceDotToComma(telegram.number1.month1),
            description,
            list: 'components.tariffs.base.info',
            color: styles.colors.telegram,
            secondColor: styles.opacityColors.telegram,
            iconComponent: TelegramIcon,
            iconHeight: 21,
            type: 'telegram',
        },
        {
            title: 'Whatsapp',
            price: replaceDotToComma(whatsapp.number1.month1),
            description,
            list: 'components.tariffs.base.info',
            color: styles.colors.whatsapp,
            secondColor: styles.opacityColors.general,
            iconComponent: WhatsAppIcon,
            iconHeight: 30,
            type: 'whatsapp',
        },
    ]


    return {
        tariffsBlock
    }
}
